export const leftMenuBreadcrumbRoutes = [
  {
    section: "System Admin",
    group: "Authorized Users",
    routes: [{ path: "/WorkflowUser", label: "Main Users" }],
  },
  {
    section: "System Admin",
    group: "Manage Entities",
    routes: [
      { path: "/ListSubcontractor/partner", label: "Subcontractors" },
      { path: "/Recruiter/partner", label: "Recruiters" },
      { path: "/ListCondidate/partner", label: "Candidates" },
    ],
  },
  {
    section: "Onboarding",
    routes: [
      { path: "/ListSubcontractor/application", label: "Subcontractors" },
      { path: "/Recruiter/application", label: "Recruiters" },
      { path: "/ListCondidate/application", label: "Candidates" },
    ],
  },
  {
    section: "Invoices",
    routes: [
      { path: "/ListCondidate/timelog", label: "Time Logs" },
      { path: "/ListCondidate/invoice", label: "Invoices & Payments" },
    ],
  },
  {
    section: "Analytics",
    routes: [
      { path: "/Dashboard", label: "Dashboard" },
      { path: "/ApplicationReport", label: "Entity Data" },
      { path: "/CustomReport/report", label: "Business Reports" },
      { path: "/CustomReport/compliance", label: "Compliance Reports" },
    ],
  },
  {
    section: "Security",
    group: "Security",
    routes: [{ path: "/MonitoringLogs", label: "Monitoring Logs" }],
  },
  {
    section: "Communications",
    group: "Emails",
    routes: [
      { path: "/PartnerEmails/mail", label: "Subcontractors" },
      { path: "/AgencyEmails/mail", label: "Recruiters" },
      { path: "/ApplicantEmails/mail", label: "Candidates" },
    ],
  },
  {
    section: "Communications",
    group: "Text Messages",
    routes: [
      { path: "/PartnerEmails/text", label: "Subcontractors" },
      { path: "/AgencyEmails/text", label: "Recruiters" },
      { path: "/ApplicantEmails/text", label: "Candidates" },
    ],
  },
  {
    section: "Communications",
    group: "Surveys",
    routes: [{ path: "/SurveyFeedback", label: "Surveys" }],
  },
];

export const normalizePath = (path = "") => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return normalized.replace(/\/+$/, "") || "/";
};

export const findLeftMenuBreadcrumb = (pathname = "") => {
  const normalizedPath = normalizePath(pathname);

  for (const menu of leftMenuBreadcrumbRoutes) {
    const matchedRoute = menu.routes.find((route) => {
      const routePath = normalizePath(route.path);
      return (
        normalizedPath === routePath ||
        normalizedPath.startsWith(`${routePath}/`)
      );
    });

    if (matchedRoute) {
      return {
        section: menu.section,
        group: menu.group,
        route: matchedRoute,
      };
    }
  }

  return null;
};

export const resolveActiveLeftMenuPath = (pathname = "", state = null) => {
  const directMatch = findLeftMenuBreadcrumb(pathname);
  if (directMatch?.route?.path) return normalizePath(directMatch.route.path);

  const normalizedPath = normalizePath(pathname);

  if (normalizedPath === "/ManageWorkflowPerformer") {
    return "/WorkflowUser";
  }

  if (normalizedPath === "/ManagePartnerPerformer") {
    if (state?.url) return normalizePath(state.url);

    if (state?.obj?.partnerType === "Sub-Contractors") {
      return "/ListSubcontractor/partner";
    }

    if (state?.obj?.partnerType === "Recruiter") {
      return "/Recruiter/partner";
    }

    return "/ListSubcontractor/partner";
  }

  if (normalizedPath === "/ReviewTask") {
    if (state?.module === "Subcontractor") {
      return "/ListSubcontractor/application";
    }
    if (state?.module === "Recruiter") {
      return "/Recruiter/application";
    }
    return "/ListCondidate/application";
  }

  if (normalizedPath === "/CandidateDetails") {
    if (state?.from === "/ReviewTask" || state?.reviewTaskState) {
      const taskState = state?.reviewTaskState;
      if (taskState?.module === "Subcontractor") {
        return "/ListSubcontractor/application";
      }
      if (taskState?.module === "Recruiter") {
        return "/Recruiter/application";
      }
      return "/ListCondidate/application";
    }

    if (state?.type) {
      return `/ListCondidate/${state.type}`;
    }
    return "/ListCondidate/application";
  }

  if (normalizedPath === "/CandidateInvoice") {
    if (state?.from === "/ReviewTask" || state?.reviewTaskState) {
      const taskState = state?.reviewTaskState;
      if (taskState?.module === "Subcontractor") {
        return "/ListSubcontractor/application";
      }
      if (taskState?.module === "Recruiter") {
        return "/Recruiter/application";
      }
      return "/ListCondidate/application";
    }
    return "/ListCondidate/invoice";
  }

  return "";
};
